import Container from "@/components/shared/AppContainer";
import { ImageBackground } from "react-native";
import React from "react";
import OnboardingContent from "./OnboardingContent";
import heroGradient from "@/assets/hero-gradient.webp";

const SignUpContainer = ({ children, ...props }) => {
  return (
    <Container {...props}>
      <ImageBackground
        resizeMode={"cover"}
        source={heroGradient}
        style={{
          flex: 1,
          width: "100%",
          height: "100%",
        }}
        imageStyle={{ borderRadius: 15 }}
      >
        <OnboardingContent wide>{children}</OnboardingContent>
      </ImageBackground>
    </Container>
  );
};

export default SignUpContainer;
